import makeStyles from '@mui/styles/makeStyles';
import { Box, Grid, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import React from 'react';
import {
  DelayedDeliveryPay,
  PayRateFormProps,
} from '../../../interfaces/PayRate';
import { generateNumberInput } from '../../../utilities/PayRates';

export const DelayedDeliveryFrom = (props: PayRateFormProps) => {
  const classes = useStyles();

  return (
    <Box component='div' className={classes.formWrapper}>
      <Grid container spacing={1} className={classes.grid}>
        <Grid key='space' item xs={2} />
        <Grid item xs={1.5}>
          <Typography className={classes.gridLabel}>Standard</Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography className={classes.gridLabel}>FAM20</Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography className={classes.gridLabel}>Hot Starbucks</Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography className={classes.gridLabel}>Cold Starbucks</Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography className={classes.gridLabel}>
            Standard Starbucks
          </Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography className={classes.gridLabel}>Robinhood</Typography>
        </Grid>
        <Grid key='space' item xs={1} />
        <Grid item xs={2} className={classes.gridItem}>
          <Typography className={classes.rowLabel}>Amount</Typography>
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            true,
            props.currentState,
            props.setter,
            'standardAmount',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            true,
            props.currentState,
            props.setter,
            'fam20Amount',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            true,
            props.currentState,
            props.setter,
            'hotStarbucksAmount',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            true,
            props.currentState,
            props.setter,
            'coldStarbucksAmount',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            true,
            props.currentState,
            props.setter,
            'standardStarbucksAmount',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            true,
            props.currentState,
            props.setter,
            'robinhoodAmount',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid key='space' item xs={1} />
        <Grid item xs={2} className={classes.gridItem}>
          <Typography className={classes.rowLabel}>Delay (Minutes)</Typography>
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            false,
            props.currentState,
            props.setter,
            'standardDelayMinutes',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            false,
            props.currentState,
            props.setter,
            'fam20DelayMinutes',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            false,
            props.currentState,
            props.setter,
            'hotStarbucksDelayMinutes',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            false,
            props.currentState,
            props.setter,
            'coldStarbucksDelayMinutes',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            false,
            props.currentState,
            props.setter,
            'standardStarbucksDelayMinutes',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            false,
            props.currentState,
            props.setter,
            'robinhoodDelayMinutes',
            props.isDisabled,
            '',
          )}
        </Grid>
        <Grid key='space' item xs={1} />
        <Grid item xs={2} className={classes.gridItem}>
          <Typography className={classes.rowLabel}>Offer Denials</Typography>
        </Grid>
        <Grid item xs={1.5}>
          {generateNumberInput<DelayedDeliveryPay>(
            false,
            false,
            props.currentState,
            props.setter,
            'standardOfferDenials',
            props.isDisabled,
            '',
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formWrapper: {
      marginTop: theme.spacing(2),
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
    },
    numberField: {
      width: 160,
      marginRight: theme.spacing(2),
    },
    boldText: {
      display: 'inline',
      fontWeight: 'bold',
    },
    grid: {
      marginTop: theme.spacing(1),
      width: '90%',
    },
    gridItem: {
      marginTop: 'auto',
      marginBottom: 'auto',
    },
    gridLabel: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '11px',
      lineHeight: '13px',
      flexGrow: 1,
      textAlign: 'left',
    },
    rowLabel: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '11px',
      lineHeight: '13px',
      flexGrow: 1,
      textAlign: 'right',
    },
  }),
);
